import { ApiId, AppRecord } from "@app/models";

import { EntityState } from "@ngrx/entity";

export enum StateStatus {
  Pending = "pending",
  Loading = "loading",
  Success = "success",
  Error = "error",
}

export const getSelectId = (state: EntityState<any>, id: ApiId): string => {
  if (!id) {
    return null;
  }
  const entity = state.ids
    .map((id) => state.entities[id])
    .find((x) => x.id == id || x._id == id);
  return (entity !== undefined && entity._id) || null;
};

export const getApiId = (value: any): ApiId => {
  return value.id || value._id;
};

// Routes must keep the stable local identity when a record later gains an
// Odoo ID during synchronization. API calls can continue to use getApiId().
export const getRouteId = (value: any): string => {
  return String(value._id || value.id);
};

export const hasRelatedId = (
  relation: ApiId | { id?: ApiId; _id?: ApiId },
  ids: ApiId[]
): boolean => {
  const relationId =
    relation && typeof relation === "object"
      ? relation._id ?? relation.id
      : relation;
  return (
    (typeof relationId === "string" || typeof relationId === "number") &&
    ids.some((id) => String(id) === String(relationId))
  );
};

/**
 *
 * Helper function used in selectors to select related items
 *
 */
export const selectRelatedItems = (
  item: AppRecord,
  itemId: ApiId | { id?: ApiId; _id?: ApiId }
): boolean => {
  if (!item) {
    return false;
  }
  const relatedId: unknown =
    itemId && typeof itemId === "object"
      ? itemId._id ?? itemId.id
      : itemId;
  const isComparableId = (value: unknown): value is ApiId =>
    typeof value === "string" || typeof value === "number";
  if (!isComparableId(relatedId)) {
    return false;
  }
  return [item._id, item.id].some(
    (id) => isComparableId(id) && String(id) === String(relatedId)
  );
};
